import { takeWhile2lajz05xm93j8 as takeWhile } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Limit.mjs';
import { collectqvo4h3wr0nez as collect } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *waitForNetwork(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.get_isOnline_xmtrl2_k$();
  yield* collect(takeWhile(tmp, waitForNetwork$slambda()), $completion);
  return Unit_instance;
}
function waitForNetwork$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return !(it === true);
  }), 1);
}
//region block: exports
export {
  waitForNetwork as waitForNetworkm2wqynq78cjd,
};
//endregion

//# sourceMappingURL=NetworkMonitor.mjs.map
